import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Chip from "@material-ui/core/Chip";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import MediaQuery from "react-responsive";

const styles = (theme) => ({
  nonBottomLine: {
    borderBottom: "none",
    fontWeight: "normal",
    fontFamily: "Roboto-regular",
    fontSize: "12pt",
  },

  tabList: {
    fontWeight: "normal",
    fontFamily: "Roboto-medium",
    fontSize: "12pt",
    opacity: "87%",
  },

  tab0: {
    minWidth: 120,
    width: 120,
  },
  tab1: {
    minWidth: 150,
    width: 150,
  },
  tab2: {
    minWidth: 200,
    width: 200,
  },
  tab3: {
    minWidth: 500,
    width: 500,
  },
});

class ExceptionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      items: [],
      numItems: -1,
      achItems: [],
      achDetails: [],
      numAchItems: -1,
      value: 1,
      selectedItemObject: {},
      selectedItemIndex: 0,
      reasons: [],
      transCodes: [],
      returnCodes: [],
    };
  }

  handleChange = (event) => {
    let currentValue = this.state.value;
    if (currentValue === 0) {
      this.setState({ value: 1 });
      this.getCheckExceptions();
    }
    if (currentValue === 1) {
      this.setState({ value: 0 });
      this.getAchExceptions();
    }
  };
  componentDidMount() {
    if (this.props.type === 1) {
      this.getCheckExceptions();
      this.setState({ value: 1 });
    } else {
      this.getAchExceptions();
      this.setState({ value: 0 });
    }
  }
  getCheckExceptions() {
    fetch("on_get_exceptions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.item.transit,
        account: this.props.item.account,
        accountIndex: this.props.item.index,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) this.setState({ errorString: reply.errorString });
          else {
            this.setState({ numItems: reply.numItems });
            this.setState({ items: reply.exceptions });
            this.setState({ returnCodes: reply.returnCodes });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }
  getAchExceptions() {
    fetch("on_get_achexceptions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.item.transit,
        account: this.props.item.account,
        accountIndex: this.props.item.index,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) this.setState({ errorString: reply.errorString });
          else {
            this.setState({ numAchItems: reply.numAchItems });
            this.setState({ achItems: reply.achExceptions });
            this.setState({ achDetails: reply.achDetails });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleSelectItem(e, action, index, item) {
    this.setState({ selectedItemIndex: index });
    this.setState({ selectedItemObject: item });
    if (action === 1)
      this.props.onCallBack(
        1,
        item,
        this.props.item.transit,
        this.props.item.account,
        this.props.secureToken,
        this.state.returnCodes
      );
    if (action === 2)
      this.props.onCallBack(
        2,
        item,
        this.props.item.transit,
        this.props.item.account,
        this.props.secureToken,
        this.getDetails(index)
      );
  }

  getDetails(itemIndex) {
    let achDetails = this.state.achDetails;
    let i;
    for (i = 0; i < achDetails.length; i++) {
      if (achDetails[i].index === itemIndex) {
        return achDetails[i].details;
      }
    }
  }

  render() {
    let { t } = this.props;
    let items = this.state.items;
    let achItems = this.state.achItems;
    const { classes } = this.props;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <div>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          </div>
        )}

        <MediaQuery query="(max-width:399px)">
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            <Tab
              classes={{ root: classes.tab0 }}
              label={<span className={classes.tabList}>{t("ach.label")}</span>}
            />
            <Tab
              classes={{ root: classes.tab0 }}
              label={
                <span className={classes.tabList}>
                  {t("checkCapital.label")}
                </span>
              }
            />
          </Tabs>
        </MediaQuery>
        <MediaQuery minWidth={400} maxWidth={500}>
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            <Tab
              classes={{ root: classes.tab1 }}
              label={<span className={classes.tabList}>{t("ach.label")}</span>}
            />
            <Tab
              classes={{ root: classes.tab1 }}
              label={
                <span className={classes.tabList}>
                  {t("checkCapital.label")}
                </span>
              }
            />
          </Tabs>
        </MediaQuery>
        <MediaQuery minWidth={501} maxWidth={999}>
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            <Tab
              classes={{ root: classes.tab2 }}
              label={<span className={classes.tabList}>{t("ach.label")}</span>}
            />
            <Tab
              classes={{ root: classes.tab2 }}
              label={
                <span className={classes.tabList}>
                  {t("checkCapital.label")}
                </span>
              }
            />
          </Tabs>
        </MediaQuery>
        <MediaQuery query="(min-width: 1000px)">
          <Tabs
            value={this.state.value}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleChange}
          >
            <Tab
              classes={{ root: classes.tab3 }}
              label={<span className={classes.tabList}>{t("ach.label")}</span>}
            />
            <Tab
              classes={{ root: classes.tab3 }}
              label={
                <span className={classes.tabList}>
                  {t("checkCapital.label")}
                </span>
              }
            />
          </Tabs>
        </MediaQuery>
        <br />
        {this.state.value === 1 && this.state.numItems > 0 && (
          <Table>
            {items.map((item) => {
              return (
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        width: "15%",
                        padding: 0,
                        color: "#2196F3",
                        textDecoration: "none",
                      }}
                      className={classes.nonBottomLine}
                      onClick={(event) =>
                        this.handleSelectItem(event, 1, item.index, item)
                      }
                    >
                      {item.checkNumber}
                    </TableCell>
                    <TableCell
                      style={{
                        width: "15%",
                        padding: 0,
                      }}
                      className={classes.nonBottomLine}
                    >
                      <Chip
                        label={item.status}
                        style={{ backgroundColor: "#2196F3" }}
                      ></Chip>
                    </TableCell>
                    <TableCell
                      style={{
                        width: "70%",
                        padding: 0,
                      }}
                      className={classes.nonBottomLine}
                    >
                      {item.reason}
                    </TableCell>
                  </TableRow>
                </TableBody>
              );
            })}
          </Table>
        )}

        {this.state.value === 1 && this.state.numItems === 0 && (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    padding: 0,
                  }}
                  className={classes.nonBottomLine}
                >
                  {" "}
                  {t("noCheckException.label")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
        {this.state.value === 0 && this.state.numAchItems > 0 && (
          <Table>
            {achItems.map((item) => {
              return (
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        padding: 0,
                        color: "#2196F3",
                        textDecoration: "none",
                      }}
                      className={classes.nonBottomLine}
                      onClick={(event) =>
                        this.handleSelectItem(event, 2, item.index, item)
                      }
                    >
                      {item.companyName}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 0,
                      }}
                      className={classes.nonBottomLine}
                    >
                      {item.subTotalAmount}
                    </TableCell>
                  </TableRow>
                </TableBody>
              );
            })}
          </Table>
        )}
        {this.state.value === 0 && this.state.numAchItems === 0 && (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    padding: 0,
                  }}
                  className={classes.nonBottomLine}
                >
                  {" "}
                  {t("noAchException.label")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
        <br />
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ExceptionsPage));
